import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: "div" | "li" | "article";
};
export function Reveal({
  children,
  className,
  delay = 0,
  as = "div"
}: RevealProps) {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  if (reduce) {
    const Static = as;
    return <Static className={className} data-id="element-433" data-mp="5r4537q8mef2">{children}</Static>;
  }
  return <Comp className={className} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: "0px 0px -10% 0px"
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1],
    delay
  }} data-id="element-434" data-mp="5paz7ung7y84">
      {children}
    </Comp>;
}